$ = require 'jquery'
actionFilterFromString = require 'lib/util/action-filter-from-string'
Action = require 'models/action'
ActionList = undefined
queueRequire -> ActionList = require 'models/collections/action-list'
ApiAjax = require 'network/api-ajax'
AttachmentList = require 'models/collections/attachment-list'
ArchivableMixin = require 'lib/archivable-mixin'
Auth = require 'db/auth'
ChecklistList = undefined
queueRequire -> ChecklistList = require 'models/collections/checklist-list'
Controller = require 'controller'
CustomFieldItem = require 'models/custom-field-item'
CustomFieldItemList = require 'models/collections/custom-field-item-list'
Dates = require 'lib/dates'
IdCache = require 'db/id-cache'
LabelList = require 'models/collections/label-list'
LabelsHelper = require 'models/internal/labels-helper'
LimitExceeded = require 'views/attachment/attachment-limit-exceeded-error'
TypeRestricted = require 'views/attachment/attachment-type-restricted-error'
LimitMixin = require 'lib/limit-mixin'
List = require 'models/list'
MemberList = undefined
queueRequire -> MemberList = require 'models/collections/member-list'
MemberState = require 'view-models/member-state'
Payloads = require 'network/payloads'
PluginDataList = require 'models/collections/plugin-data-list'
Promise = require 'bluebird'
StickerList = require 'models/collections/sticker-list'
TrelloModel = require 'models/internal/trello-model'
Util = require 'lib/util'
_ = require 'underscore'
mixin = require 'lib/mixin'
moment = require 'moment'
ninvoke = require 'lib/util/ninvoke'
xtend = require 'xtend'

module.exports = class Card extends TrelloModel
  mixin LabelsHelper, ArchivableMixin, LimitMixin, @
  EDITING_AUTO_CLEAR_MS = 10000

  typeName: 'Card'
  urlRoot: '/1/cards'

  initialize: ->
    @destruct [
      @memberList = new MemberList().syncModel(@, 'idMembers')
      @labelList = new LabelList()
        .syncModel(@, 'idLabels')
        .syncCache @modelCache, [], (label) =>
          label.id in (@get('idLabels') ? [])
      @memberVotedList = new MemberList().syncModel(@, 'idMembersVoted')
      @checklistList = new ChecklistList().syncCache @modelCache, ['idCard'], (checklist) =>
        checklist.get('idCard') == @id
      @attachmentList = new AttachmentList().syncSubModels(@, 'attachments')
      @actionList = new ActionList().syncCache @modelCache, [], (action) =>
        isComment = action.get('type') in ['commentCard', 'copyCommentCard']
        isSameBoard = action.get('data').board?.id == @get('idBoard')
        action.includesModel(@) && (isComment || isSameBoard)
      @stickerList = new StickerList(@get('stickers'), { card: @, @modelCache }).syncSubModels(@, 'stickers')
      @customFieldItemList = new CustomFieldItemList().syncCache @modelCache, [], (cfi) =>
        cfi.get('idModel') == @id && cfi.get('modelType') == 'card'
      @pluginDataList = new PluginDataList([], {
        scopeModel: @
      }).syncCache @modelCache, [], (pluginData) =>
        pluginData.get('idModel') == @id && pluginData.get('scope') == 'card'

      @memberEditingList = new MemberList()
    ]

    @listenTo @, 'change:id change:idBoard', =>
      @actionList.sync()

    @_initSubEventsOn 'badges'
    @cacheShortLink()

  isVisibleAction: (action) ->
    @_actionFilter ?= actionFilterFromString(Payloads.cardActions)
    @_actionFilter(action)

  cacheShortLink: ->
    @waitForAttrs @, ['id', 'shortLink'], ({ id, shortLink }) ->
      IdCache.setCardId(shortLink, id)

  updateEditing: (member) ->
    @_editingTimeout ?= {}

    # This is a no-op if member is already in the list
    @memberEditingList.add(member)

    if @_editingTimeout[member.id]?
      clearTimeout @_editingTimeout[member.id]
      delete @_editingTimeout[member.id]

    @_editingTimeout[member.id] = @setTimeout =>
      @memberEditingList.remove(member)
    , EDITING_AUTO_CLEAR_MS

  sync: (method, model, options) ->
    if method == 'create' && !(@get('idBoard')? && @get('idList')?)
      @waitForAttrs @, ['idBoard', 'idList'], (attrs) =>
        @set(attrs)
        super(method, model, options)

      @waitForId @getBoard(), (id) => @set('idBoard', id)
      @waitForId @getList(), (id) => @set('idList', id)
    else
      super

  set: (key, options) ->
    if key?.labels
      key.labels = (label.color ? label for label in key.labels)

    if key?.badges
      key.badges = xtend(@get('badges'), key.badges)

    super


  moveToList: (listDest, index, keyboardMove = false) ->
    card = @

    @waitForId listDest, (idList) =>
      newPos = listDest.calcPos(index, card)
      composer = listDest.getBoard().composer

      if newPos == card.get('pos') && card.get('idList') == idList && card.isOpen()
        # if we were not removing the card from the archive,
        # handle if we were just swapping the card with the composer
        composerIndex = composer.get('index')
        if composerIndex == index
          composer.set('index', composerIndex + 1)
        else if composerIndex == index + 1
          composer.set('index', composerIndex - 1)

        return

      sourceIdList = card.get('idList')
      sourceIndex = card.getIndexInList()

      delta =
        pos: newPos
        idList: idList
        idBoard: listDest.getBoard().id
        closed: false

      for key, value of delta when card.get(key) == value
        delete delta[key]

      if keyboardMove
        setTimeout -> card.trigger('keyboardMove')

      card.update delta

      if composer?.get('vis')
        composerIndex = origIndex = composer.get('index')

        if composer.get('list').id == idList && composer.get('index') >= index
        # if we moved a card to above the composer, increment the position
        # note: we have no way to differentiate between moving a card to just
        # above/just below the composer, so assume above
          composerIndex++

        if composer.get('list').id == sourceIdList && composer.get('index') > sourceIndex
          composerIndex--

        composer.set('index', composerIndex)

  moveToNextList: (position) ->
    listList = @getBoard().listList.models
    indexCurrentList = _.indexOf(listList, @getList())
    if (indexCurrentList < listList.length - 1)
      @moveToList(listList[indexCurrentList + 1], (if position == 'top' then 0 else 1e9), true)
    return

  moveToPrevList: (position) ->
    listList = @getBoard().listList.models
    indexCurrentList = _.indexOf(listList, @getList())
    if (indexCurrentList > 0)
      @moveToList(listList[indexCurrentList - 1], (if position == 'top' then 0 else 1e9), true)
    return

  toggleMember: (idMember, [isMember]..., next) ->
    isMember ?= !@hasMember(idMember)

    if isMember && Auth.isMe(idMember)
      @set('subscribed', true)

    @toggle('idMembers', idMember, isMember, next)

  addMember: (idMember, next) -> @toggleMember(idMember, true, next)
  removeMember: (idMember, next) -> @toggleMember(idMember, false, next)

  hasMember: (idMember) ->
    @memberList.get(idMember)

  getIdCardMems: -> _.map(@memberList.models, (member) => member.id )

  hasChecklist: (idChecklist) ->
    @checklistList.get(idChecklist)

  close: (next) ->
    @update
      closed: true,
      next
    return

  reopen: ->
    list = @getList()
    if list?
      @update
        closed: false
        pos: list.calcPos(list.cardList.length, @)
    return

  getBoard: ->
    @modelCache.get('Board', @get('idBoard')) ? @getList()?.getBoard()

  getIndexInList: ->
    list = @getList()
    # It's possible that the list won't exist if we've only ever loaded the
    # card model
    if list?
      _.indexOf(list.cardList.models, @)
    else
      -1

  getList: ->
    @modelCache.get('List', @get('idList')) ? @collection?.owner

  getUrl: -> Controller.getCardUrl(@)
  getFullUrl: -> "#{ siteDomain }#{ @getUrl() }"

  getDueDate: ->
    if @get('badges')?.due
      new Date(@get('badges').due)
    else
      null

  editable: => @getBoard()?.editable()

  canAttach: ->
    @editable() &&
    !@isOverLimit('attachments', 'perCard') &&
    !@getBoard().isOverLimit('attachments', 'perBoard')

  attachmentTypeRestricted: (attachmentType) ->
    @getBoard().attachmentTypeRestricted(attachmentType)

  attachmentUrlRestricted: (url) ->
    @getBoard().attachmentUrlRestricted(url)

  canDropAttachment: (eventType) ->
    (eventType == 'dd-enter:files' && !@attachmentTypeRestricted('computer')) ||
    (eventType == 'dd-enter:url' && !@attachmentTypeRestricted('link'))

  # we always want this to be "the latest comment",
  # but we have to deal with our clock being out of
  # sync with the server, and our "now" actually
  # being "before" an existing comment.
  dateForNewComment: ->
    if @actionList.length == 0
      new Date()
    else
      latestAction = @actionList.sort().first()
      afterLatest = moment(latestAction.getDate()).add(1, 'seconds').toDate()
      _.max [new Date(), afterLatest]

  addComment: (comment) ->
    card = @

    if (comment != "")
      return new Promise (resolve, reject) => @waitForId card, (idCard) =>
        board = card.getBoard()
        actionPlaceholder = new Action
          type: 'commentCard'
          date: @dateForNewComment()
          data:
            text: comment
            card:
              id: card.id
              name: card.get('name')
            board:
              id: board.id
              name: board.get('name')
            textData:
              emoji: Auth.me().allCustomEmoji()
          idMemberCreator: Auth.myId()
          display:
            translationKey: 'action_comment_on_card'
            entities:
              card:
                hideIfContext: true
                id: card.id
                isContext: false
                shortLink: card.shortLink
                text: comment
                type: 'card'
              comment:
                text: comment
                type: 'comment'
              contextOn:
                hideIfContext: true
                idContext: card.id
                translationKey: 'action_on'
                type: 'translatable'
              memberCreator:
                id: Auth.myId()
                isContext: false
                text: Auth.me().get('fullName')
                type: 'member'
                username: text: Auth.me().get('fullName')
        ,
          modelCache: @modelCache

        timeout = @setTimeout ->
          actionPlaceholder.takingTooLong()
        , 2000

        ApiAjax
          url: "/1/cards/#{ card.id }/actions/comments"
          type: 'post'
          data:
            text: comment
          dataType: 'json'
          error: (e) =>
            clearTimeout(timeout)
            reject(e)
          success: (resp) =>
            resolve(actionPlaceholder)
            clearTimeout(timeout)
            actionPlaceholder.isTakingTooLong = false
            @modelCache.enqueueDelta actionPlaceholder, resp

    return Promise.resolve()

  changeDueDateMaintainTime: (targetDate) ->
    oldDateData = new Date(@get('due')) ? new Date().setHours(12, 0, 0, 0)
    newDate = Dates.getDateWithSpecificTime(oldDateData, targetDate)
    @update(due: newDate)

  vote: (voteVal) ->
    if !@getBoard().canVote(Auth.me())
      return

    # We have to do this locking business so we don't get the client state out of sync with the server
    @waitForLock 'vote', (next) =>
      if voteVal == @voted()
        return next()

      # Unfortunately we have to mess with the badges to make sure
      # the vote takes effect immediately on the client side
      badges = _.clone(@get('badges')) ? {}

      if voteVal
        badges.votes++
        badges.viewingMemberVoted = true
      else
        badges.votes--
        badges.viewingMemberVoted = false
      @set('badges', badges)

      @toggle 'idMembersVoted', Auth.myId(), voteVal, { collectionName: 'membersVoted' }, next

      return

  voted: ->
    @get('badges')?.viewingMemberVoted ? false

  hasStickers: ->
    @stickerList.length > 0

  hasCover: ->
    @attachmentList.get(@get('idAttachmentCover'))?

  getAllAgingClasses: ->
    'aging-level-0 aging-level-1 aging-level-2 aging-level-3 aging-pirate aging-regular'

  getAgingData: ->
    board = @getBoard()
    timeInactive = Date.now() - new Date(@get('dateLastActivity'))

    data =
      level: switch
        when timeInactive < Util.getMs(days: 7)
          0
        when timeInactive < Util.getMs(days: 14)
          1
        when timeInactive < Util.getMs(days: 28)
          2
        else
          3
      mode: board.get('prefs').cardAging

    data.agingClassesToAdd = "aging-level-#{data.level} aging-#{data.mode}"
    if /64$/.test(@id) then data.agingClassesToAdd += ' aging-treasure'

    data

  toggleVote: ->
    @vote(!@voted())
    return

  subscribe: (subscribed, next) ->
    return if subscribed == @get('subscribed')

    badges = @get('badges') || {}
    badges.subscribed = subscribed

    @update { subscribed }, next

    return

  isSubscribed: ->
    _.some [
      @get('subscribed')
      @get('badges')?.subscribed
      @getBoard()?.get('subscribed')
      @getList()?.get('subscribed')
    ]

  getCheckItem: (idCheckItem) ->
    for i in [0..@checklistList.length - 1]
      checklist = @checklistList.at(i)
      checkItem = checklist?.checkItemList?.get(idCheckItem)
      if (checkItem)
        return checkItem

    null

  toJSON: (opts = {}) ->
    data = super

    if opts.url
      data.url = Controller.getCardUrl(@)

    data

  upload: (file, name, next) ->
    fd = new FormData()
    fd.append('token', Auth.myToken())
    if name?
      fd.append('file', file, name)
    else
      # Firefox 22 will call the file "undefined" if you have an undefined
      # value as the 3rd parameter
      fd.append('file', file)
    ApiAjax
      url: "/1/cards/#{ @id }/attachments"
      data: fd
      type: 'post'
      processData: false
      contentType: false
      retry: false
      error: ({ status, responseJSON }, textStatus, error, fxDefault) =>
        if @_isTooManyAttachments(status, responseJSON?.error)
          next(LimitExceeded())
        else if status in [0, 413]
          next("Error uploading #{ file.name ? name }")
        else
          # Default is to retry
          fxDefault()
      success: (attachment) =>
        @set('attachments', [attachment, (@get('attachments') ? [])...])
        next(null, attachment)
      timeout: Util.getMs(hours: 6) # Gold lets you upload 250MB attachments

  uploadUrl: (data, next = ->) ->
    if _.isString(data)
      data =
        url: data

    ApiAjax
      url: "/1/cards/#{ @id }/attachments"
      type: 'post'
      data: data
      error: ({ status, responseJSON }, textStatus, error, fxDefault) =>
        if @_isTooManyAttachments(status, responseJSON?.error)
          next(LimitExceeded())
        else if @_isAttachmentTypeRestricted(status, responseJSON?.error)
          next(TypeRestricted())
        else
          next(textStatus)
      success: (attachment) =>
        @set('attachments', [attachment, (@get('attachments') ? [])...])
        next(null, attachment)

  removeCover: ->
    @update(idAttachmentCover: '')

  makeCover: (attachment) ->
    @update(idAttachmentCover: attachment.id)

  calcChecklistPos: (index, checklist) ->
    Util.calcPos(index, @checklistList, checklist)

  calcAttachmentPos: (index, attachment) ->
    # if one `pos` is null, they all are!
    # TODO gerard remove this code after the server backfills attachment positions
    if attachment.get('pos') == null
      @attachmentList.models.forEach((attachment, i) ->
        pos = (i + 1) * 16384
        attachment.update('pos', pos)
      )

    # We need to do this since the server considers higher positions to be
    # more recent by default. Since we sort from most recent to least recent
    # by default, that means we're sorting from higher `pos` to lower `pos`.
    # Thus, our position calculation needs to be reversed
    reversedIndex = @attachmentList.length - index - 1
    Util.calcPos(reversedIndex, @attachmentList, attachment)

  _isTooManyAttachments: (status, error) ->
    status == 403 && (
      error == "CARD_TOO_MANY_ATTACHMENTS" ||
      error == "BOARD_TOO_MANY_ATTACHMENTS"
    )

  _isAttachmentTypeRestricted: (status, error) ->
    status == 403 && error == "CARD_ATTACHMENT_TYPE_RESTRICTED"

  _neighbor: (delta) ->
    cards = @getList().openCards()
    filter = @getBoard().filter
    cardIndex = cards.indexOf(@)
    if cardIndex >= 0
      cardIndex += delta
      while cards.at(cardIndex)? && !filter.satisfiesFilter(cards.at(cardIndex))
        cardIndex += delta

      cards.at(cardIndex)
    else
      null

  prevCard: -> @_neighbor(-1)
  nextCard: -> @_neighbor(1)

  # For the LabelsHelper mixin
  labelCreateUrl: -> "/1/card/#{@id}/labels/"

  copyTo: ({ name, idList, pos, keepFromSource }) ->
    name ?= @get('name')

    List.load(idList, Payloads.listMinimal, @modelCache)
    .then (list) =>
      ninvoke list.cardList, 'create', { name, pos },
        createData:
          idCardSource: @id
          keepFromSource: keepFromSource

  setPluginData: (idPlugin, visibility, data) ->
    @pluginDataList.upsert(idPlugin, visibility, data)

  getPluginData: (idPlugin) ->
    @pluginDataList.dataForPlugin(idPlugin)

  snoopPluginData: (idPlugin) ->
    cardPluginData = @pluginDataList.snoopDataForPlugin(idPlugin)

  getAgeMs: ->
    if @id
      Date.now() - new Date(Util.idToDate(@id))
    else
      0

  getIdMemberCreator: ->
    createAction = @actionList.find (action) ->
      action.get('type') in ['createCard', 'copyCard']

    createAction?.get('idMemberCreator')

  getDates: ->
    if !@getBoard().isCustomFieldsEnabled()
      return []
    @customFieldItemList.filter (cfi) ->
      cfi.getCustomField()?.get('type') == 'date' && !cfi.isEmpty()

  shouldSuggestDescription: ->
    # Determine if the user probably wants to edit the description of the card
    # We guess they'd want that if it's a card that they created recently and
    # there isn't any discussion on it yet
    idMe = Auth.myId()

    !@get('desc') &&
    @editable() &&
    @getAgeMs() < Util.getMs({ minutes: 5 }) &&
    !(@get('badges')?.comments > 0) &&
    (@actionList.length == 0 || @getIdMemberCreator() == idMe)

  isVisible: ->
    @isOpen() && @getList()?.isOpen()

  getCustomFieldItem: (idCustomField) ->
    @customFieldItemList.find (cfi) ->
      cfi.get('idCustomField') == idCustomField

  markAssociatedNotificationsRead: ->
    if !Auth.isLoggedIn()
      return
    ApiAjax
      url: "#{ @urlRoot }/#{ @id }/markAssociatedNotificationsRead"
      type: 'post'
      background: true



// WEBPACK FOOTER //
// ./app/scripts/models/card.coffee